"use client";
import Image from "next/image";
import 프랜차이즈_목록_이미지1 from "/public/assets/mobile/images/pic/img_franchise_list1.webp";
import 프랜차이즈_목록_이미지2 from "/public/assets/mobile/images/pic/img_franchise_list2.webp";
import 프랜차이즈_목록_이미지3 from "/public/assets/mobile/images/pic/img_franchise_list3.webp";
import styles from "./프랜차이즈_목록_Mobile.module.css";
import { 링크 } from "./데이터/링크";

export type 프랜차이즈_목록Props = {
  inline?: boolean;
}

export const 프랜차이즈_목록_Mobile = (props?: 프랜차이즈_목록Props) => {
  function ButtonWrap() {
    return (
      <div className={styles["btn-wrap"]}>
        <a href={링크.프랜차이즈} className={styles["btn-usage-guide"]}>
          프랜차이즈 <span className={"fc1"}>이용가이드</span> 바로가기
        </a>
      </div>
    );
  }

  return (
    <div className={props?.inline === true ? "section section11" : "section section10"}>
      <div className="inner">
        <div style={{ textAlign: "center", color: "#ffffff", fontSize: "22px", lineHeight: "28px", fontWeight: 700, letterSpacing: "-3%" }}>마켓봄은 프랜차이즈와 함께<br/> 성장해 나갑니다.</div>
        <div id="franchise-slider" style={{marginTop: "30px"}}>
          <div className={styles["image-box1"]}>
            <Image src={프랜차이즈_목록_이미지1} alt="프랜차이즈" style={{ marginRight: "10px" }} />
            <Image src={프랜차이즈_목록_이미지1} alt="프랜차이즈" />
          </div>
        </div>
        <div id="franchise-slider" style={{marginTop: "12px"}}>
          <div className={styles["image-box2"]}>
            <Image src={프랜차이즈_목록_이미지2} alt="프랜차이즈" style={{ marginRight: "10px" }} />
            <Image src={프랜차이즈_목록_이미지2} alt="프랜차이즈" />
          </div>
        </div>
        <div id="franchise-slider" style={{marginTop: "12px"}}>
          <div className={styles["image-box3"]}>
            <Image src={프랜차이즈_목록_이미지3} alt="프랜차이즈" style={{ marginRight: "10px" }} />
            <Image src={프랜차이즈_목록_이미지3} alt="프랜차이즈" />
          </div>
        </div>
      </div>
      { props?.inline === true ? <></> : <ButtonWrap></ButtonWrap>}
    </div>
  );
};
